const synth = window.speechSynthesis;

function queueMessage(message: string) {
    const utt = new SpeechSynthesisUtterance(message);
    synth.speak(utt);
}

function clearQueue() {
    synth.cancel();
}

export default { queueMessage, clearQueue };
